// extracted by mini-css-extract-plugin
export default {"content":"styles_content__xMndQ","section1":"styles_section1__E-2mp","section2":"styles_section2__zwQG6","section3":"styles_section3__XxYIx","downArrow":"styles_downArrow__3l77L"};